import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import Discount from '../models/Discount'

export default class DiscountViewModel extends BaseViewModel {
  constructor(view) {
    super(view)
  }
  // INICIALIZADORES

  //#region CRUD

  onCreate() {
    let item = new Discount({
      state: "create",
      status: 1
    });
    return item;
  }

  onDelete(data) {
    let item = new Discount(data);
    item.state = "delete";
    return item;
  }

  onEdit(data) {
    let item = new Discount(data);
    item.state = "update";
    return item;
  }

  onSearchCollection() {
    return this.api.discounts.find(this.getSearchQuery())
  }

  mapCollection(collection) {
    return _.map(collection, (data) => new Discount(data));
  }

  onSearchItem(id) {
    return this.api.discounts.findOne(id)
  }

  onSave(data) {
    if (data.state === 'create')
      return this.api.discounts.create(data.toSend())
    else
      return this.api.discounts.update(data.id, data.toSend());
  }

  onDestroy(context, id) {
    context.api.discounts.delete(id)
      .then(response => context.view.onSuccess(response.data))
      .catch(context.view.onError)
  }

  onCancel(context) {
    context.view.item = null;
  }

  import(file) {
    this.api.discounts.import(file)
      .then(response => this.view.onImportResponse(response.data))
      .catch(this.view.onError)
  }

  exportToExcel() {
    this.api.discounts.exportToExcel()
      .then(response => this.view.onExportResponse(response.data))
      .catch(this.view.onError)
  }

  // #endregion

  // #region BINDING DATA

  bindFormView() {
    if (this.view.formData.state === 'update') {
      let data = this.view.formData
      this.view.formData.reportDate = [data.startDate, data.endDate];
      this.view.subscriptionPlans = this.view.formData.subscriptionPlan ? [this.view.formData.subscriptionPlan] : []
    }
    setTimeout(() => {
      this.showModalLoading(this.view.conf, false);
    }, 400);
  }

  // #endregion

  // #region QUERIES
  findHistoryCollection() {
    this.api.discounts.findHistory(this.getSearchQuery())
      .then((response) => this.view.onFindHistoryCollectionResponse(response.data.data))
      .catch(this.view.onError);
  }
  onSearchSubscriptionPlans(criteria) {
    this.api.subscriptionPlans.find(criteria)
      .then((response) => this.view.onSearchSubscriptionPlansResponse(response.data))
      .catch(this.view.onError)
  }

  /**
   * Metodo para buscar descuento
   * @param {String} data Query string para parametros de búsqueda
   */
  findDiscounts(data) {
    this.api.discounts.find(data)
      .then((response) => this.view.onSearchDiscountsResponse(response.data.data))
      .catch(this.view.onError)
  }

  // #endregion

  //#region MAPPING DATA


  // #endregion

  // #region VALIDATIONS

  // #endregion
}
